import { render } from "./OurValues.vue?vue&type=template&id=8daf5c54&scoped=true"
import script from "./OurValues.vue?vue&type=script&lang=js"
export * from "./OurValues.vue?vue&type=script&lang=js"

import "./OurValues.vue?vue&type=style&index=0&id=8daf5c54&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bomoindustrial-vue/bomoindustrial-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8daf5c54"]])

export default __exports__